import LaunchDarkly from '@module/launchdarkly';
import { EXPERIMENT_VIDEO_UPLOADS } from '@constant/experiments';

export const SUPPORTED_IMAGE_TYPES = ['image/png', 'image/jpg', 'image/jpeg'];
export const SUPPORTED_VIDEO_TYPES = ['video/mp4'];

export function getSupportedWallpaperTypes() {
  return LaunchDarkly.getVariant(EXPERIMENT_VIDEO_UPLOADS)
    ? SUPPORTED_IMAGE_TYPES.concat(SUPPORTED_VIDEO_TYPES)
    : SUPPORTED_IMAGE_TYPES;
}
